import { graphql } from "@/graphql/codegen"

graphql(`
  query GetGlPostingAccountOptions($input: GlAccountListInput!) {
    glAccount {
      list(input: $input) {
        ... on GlAccountListSuccess {
          glAccounts {
            glAccountId
            number
            subNumber
            title
          }
          pageInfo {
            total
            limit
            offset
          }
        }
        ... on GlAccountFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
